var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_7715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.45863 0.864206L8.31683 2.00601L11.3837 5.07284L12.5255 3.93103C13.1152 3.34126 13.1152 2.38582 12.5255 1.79605L11.596 0.864206C11.0062 0.274431 10.0508 0.274431 9.46099 0.864206H9.45863ZM7.78367 2.53917L2.28461 8.04058C2.03927 8.28593 1.85997 8.59025 1.76089 8.92289L0.925771 11.7609C0.866794 11.9614 0.921053 12.1761 1.06732 12.3223C1.21358 12.4686 1.42826 12.5229 1.62642 12.4663L4.46442 11.6311C4.79705 11.532 5.10138 11.3528 5.34672 11.1074L10.8505 5.60599L7.78367 2.53917Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_7715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.0786,
    height: 12.0786,
    fill: "white",
    transform: "translate(0.902344 0.40918)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.ff3af539fc0cce5c9292e93d1f84a151.svg";
export { ForwardRef as ReactComponent };